import React from 'react';
import ReportText from './ReportText';
import ReactHtmlParser from 'react-html-parser';

const Br = () => '\n';

const transform = (node, index) => {
  if (node.type === 'tag' && node.name === 'strong') {
    return (
      <ReportText key={index} style={{ fontWeight: 'bold' }}>
        {node.children[0].data}
      </ReportText>
    );
  }

  if (node.type === 'tag' && node.name === 'br') {
    return <Br key={index} />;
  }

  return undefined;
};

const ReportTextHtml = ({ children, style }) => {
  return <ReportText style={style}>{ReactHtmlParser(children, { transform })}</ReportText>;
};

export default ReportTextHtml;
